import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useOrganizationUserRoles = () => {
  const queryClient = useQueryClient();
  
  const updateUserRole = useMutation({
    mutationFn: async ({ 
      userId, 
      newRole 
    }: { 
      userId: string; 
      newRole: 'standard' | 'admin' | 'editor' 
    }) => {
      const { data, error } = await supabase
        .from('user_roles')
        .update({ role: newRole })
        .eq('user_id', userId)
        .select()
        .single();
      
      if (error) throw error;
      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['organization-users'] });
      queryClient.invalidateQueries({ queryKey: ['user-role', data.user_id] });
      queryClient.invalidateQueries({ queryKey: ['user-roles'] });
      toast.success(`User role updated to ${data.role}`);
    },
    onError: (error: any) => {
      console.error('Error updating user role:', error);
      toast.error(error.message || "Failed to update user role");
    }
  });
  
  return { updateUserRole };
};
